import { MergeFileType } from "@/pages/FilePage/hooks/useFileData";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootEpic } from "../types";
import { ofType } from "redux-observable";
import { map } from "rxjs";
import { deleteFileActions } from "../deleteFile";

export interface SelectedFilesState {
  selectedFiles: MergeFileType[];
  logCount: number;
}

const initialState: SelectedFilesState = {
  selectedFiles: [],
  logCount: 0,
};

const selectedFilesSlice = createSlice({
  name: "selectedFiles",
  initialState,
  reducers: {
    selectFiles: (state, action: PayloadAction<MergeFileType[]>) => {
      action.payload.forEach((file) => {
        if (!state.selectedFiles.find((f) => f.id === file.id)) {
          state.selectedFiles.push(file);
        }
      });
    },

    deselectFile: (state, action: PayloadAction<number | string>) => {
      const idToRemove = String(action.payload);
      state.selectedFiles = state.selectedFiles.filter(
        (f) => String(f.id) !== idToRemove
      );
    },

    selectFilesBulk: (state, action: PayloadAction<MergeFileType[]>) => {
      action.payload.forEach((file) => {
        if (!state.selectedFiles.find((f) => f.id === file.id)) {
          state.selectedFiles.push(file);
        }
      });
    },

    clearSelectedFiles: (state) => {
      state.selectedFiles = [];
    },
    incrementLogCount: (state, action: PayloadAction<number>) => {
      state.logCount += action.payload;
    },
    setLogCount: (state, action: PayloadAction<number>) => {
      state.logCount = action.payload;
    },
  },
});

export const deleteFileEpic$: RootEpic = (action$) =>
  action$.pipe(
    ofType(deleteFileActions.deleteFileRequest.type),
    map((action: ReturnType<typeof deleteFileActions.deleteFileRequest>) => {
      const { fileId } = action.payload;
      return selectedFilesActions.deselectFile(fileId);
    })
  );

  export const selectedFilesEpic = [deleteFileEpic$];

export const selectedFilesActions = selectedFilesSlice.actions;
export default selectedFilesSlice.reducer;
